import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AdminService} from "../dashboard/services/admin.service";
import {ParameterService} from "../../_services/parameter.service";

@Component({
    selector: 'admin-support-inbox',
    templateUrl: './support-inbox.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class SupportInboxComponent extends BasePageComponentDirective<any> implements OnInit {
    messages: any[] = [];
    ticketStatus: any = {};
    constructor(
        injector: Injector,
        private adminService: AdminService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.ticketStatus = await this.parameterService.getParameterByName("TICKET_STATUS");
        this.query();

    }

    conversation(id: number) {
        this.router.navigate(['/office/inbox/' + id + '/conversation']).then();
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['subject', 'status', 'id'];
        this.adminService.getWalletSupport(this.pageQuery).then(r => {
            this.messages = r.content;
            this.page.emit(r);
        });
    }


}
